import axios, { AxiosResponse } from "axios";
import {AutoLoginCredentials, AutoLoginResponse} from "./types";

export const autoLoginMutation = async (
  {verification_token, checksum}: AutoLoginCredentials): Promise<AxiosResponse<AutoLoginResponse>> => {
  const response = await axios.get('/api/auth/auto-login/', {params: {verification_token, checksum}})
  return response
}
